import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';
import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ViewClient = () => {

    const [users, setUsers] = useState([]);

    useEffect(() => {
        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("clnt");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("vclient");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }        

        // Fetch users when component mounts
        getUsers();

        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }            
        };
    }, []); // Empty dependency array ensures this effect runs only once

    function getUsers() {
        axios.get('https://react-apis.dotlocalhost.com/clientShow.php').then(function (response) {
            console.log(response.data);
            setUsers(response.data);
        });
    }

    const deleteUser = (id) => {
        axios.delete(`https://react-apis.dotlocalhost.com/clientShow.php/${id}/delete`).then(function (response) {
            console.log(response.data);
            alert('Record has been deleted successfully!');
            getUsers();
        });
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />
                <div className='ineerBody'>
                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>View All Clients</h3>
                        </div>
                    </div>

                    <Table striped bordered hover style={{ fontSize: '12px' }}>
                        <thead>
                            <tr style={{ textAlign: 'center', backgroundColor: '#C0D4D9', color: '#000000' }}>
                                <th>Date</th>
                                <th>Client Name</th>
                                <th>Client ID</th>
                                <th>Status</th>
                                <th>Address</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Opening Balance</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody style={{ padding: "3px", textAlign: "left" }}>
                            {users.map((user, key) => (
                                <tr key={key}>
                                    <td style={{ textAlign: 'center' }}>{user.date}</td>
                                    <td>{user.clientName}</td>
                                    <td style={{ textAlign: 'center' }}>{user.clid}</td>
                                    <td>{user.status}</td>
                                    <td>{user.address}</td>
                                    <td>{user.email}</td>
                                    <td style={{ textAlign: 'right', paddingRight: '3%' }}>{user.mobile}</td>
                                    <td style={{ textAlign: 'right', paddingRight: '3%' }}>{user.opening_balance}</td>
                                    <td>
                                        <Link to={`/edit-client/${user.id}`} style={{ marginRight: "10px", fontSize: "10px" }} className="btn btn-warning">Edit Client</Link>
                                        <button onClick={() => deleteUser(user.id)} style={{ marginRight: "10px", fontSize: "10px" }} className="btn btn-danger">Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
}

export default ViewClient;
